"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _loggingStateService = require("@smartsheet/logging-state-service");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../theme/utils/useTheme");
var _logging = require("../../util/logging");
var _RadioIcon = require("./styled/RadioIcon");
var _RadioInnerDot = require("./styled/RadioInnerDot");
var _RadioInput = require("./styled/RadioInput");
var _RadioLabel = require("./styled/RadioLabel");
var _RadioLabelText = require("./styled/RadioLabelText");
// Currently this only supports strings.

const Radio = props => {
  const {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedBy,
    id,
    isDisabled = false,
    isRequired,
    isInvalid = false,
    isChecked = false,
    label,
    name,
    onBlur: providedOnBlur,
    onChange: providedOnChange,
    onMouseDown: providedOnMouseDown,
    onMouseUp: providedOnMouseUp,
    onMouseEnter: providedOnMouseEnter,
    onMouseLeave: providedOnMouseLeave,
    onInvalid,
    value,
    clientId,
    className,
    size = "large",
    ...rest
  } = props;
  const loggingCtx = (0, _react.useContext)(_loggingStateService.LoggerContext);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const [isHovered, setIsHovered] = (0, _react.useState)(false);
  const [isActive, setIsActive] = (0, _react.useState)(false);
  const [isMouseDown, setIsMouseDown] = (0, _react.useState)(false);
  const generatedId = (0, _react.useMemo)(() => (0, _lodestarUtils.genId)("radio"), []);
  const idToUse = id || generatedId;
  const onBlur = (0, _react.useCallback)(event => {
    // onBlur is called after onMouseDown if the radio was focused, however
    // in this case on blur is called immediately after, and we need to check
    // whether the mouse is down.
    setIsActive(isMouseDown && isActive);
    if (providedOnBlur) {
      providedOnBlur(event);
    }
  }, [isActive, isMouseDown, providedOnBlur]);
  const onMouseLeave = (0, _react.useCallback)(event => {
    setIsActive(false);
    setIsHovered(false);
    if (providedOnMouseLeave) {
      providedOnMouseLeave(event);
    }
  }, [providedOnMouseLeave]);
  const onMouseEnter = (0, _react.useCallback)(event => {
    setIsHovered(true);
    if (providedOnMouseEnter) {
      providedOnMouseEnter(event);
    }
  }, [providedOnMouseEnter]);
  const onMouseUp = (0, _react.useCallback)(event => {
    setIsActive(false);
    setIsMouseDown(false);
    if (providedOnMouseUp) {
      providedOnMouseUp(event);
    }
  }, [providedOnMouseUp]);
  const onMouseDown = (0, _react.useCallback)(event => {
    setIsActive(true);
    setIsMouseDown(true);
    if (providedOnMouseDown) {
      providedOnMouseDown(event);
    }
  }, [providedOnMouseDown]);
  const onChange = (0, _react.useCallback)(event => {
    if (!isDisabled) {
      void new _logging.LoggingDecorator(loggingCtx, {
        clientId,
        controlType: "rdo"
      }).enabledByDefault({
        actionId: _loggingStateService.LogActionId.CLICK
      }, providedOnChange)(event);
    }
  }, [clientId, loggingCtx, providedOnChange, isDisabled]);
  const Root = (0, _react.useMemo)(() => label ? _RadioLabel.RadioLabel : _RadioLabel.RadioLabel.withComponent("div"), [label]);
  const eventHandlers = isDisabled ? {} : {
    onMouseDown,
    onMouseEnter,
    onMouseLeave,
    onMouseUp
  };
  const styleProps = {
    isActive,
    isChecked,
    isDisabled,
    isHovered,
    isInvalid,
    size,
    themeMode
  };
  return /*#__PURE__*/_react.default.createElement(Root, {
    "data-client-id": clientId && `${clientId}--radio-label`,
    className: className
    // Only apply this if there's actually a label.
    ,
    htmlFor: label ? idToUse : undefined,
    themeMode: themeMode
  }, /*#__PURE__*/_react.default.createElement(_RadioIcon.RadioIcon, (0, _extends2.default)({}, styleProps, {
    "data-client-id": clientId && `${clientId}--radio-icon`
  }), /*#__PURE__*/_react.default.createElement(_RadioInput.RadioInput, (0, _extends2.default)({
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedBy,
    checked: isChecked,
    "aria-disabled": isDisabled,
    id: idToUse,
    name: name,
    onChange: onChange,
    onBlur: onBlur,
    onInvalid: onInvalid,
    required: isRequired,
    type: "radio",
    value: value,
    "data-client-id": clientId && `${clientId}--hidden-radio`
  }, eventHandlers, rest)), /*#__PURE__*/_react.default.createElement(_RadioInnerDot.RadioInnerDot, (0, _extends2.default)({}, styleProps, {
    "data-client-id": clientId && `${clientId}--radio-dot`
  }))), label ? /*#__PURE__*/_react.default.createElement(_RadioLabelText.RadioLabelText, (0, _extends2.default)({}, eventHandlers, {
    size: size,
    isChecked: isChecked,
    isDisabled: isDisabled,
    themeMode: themeMode,
    "data-client-id": clientId && `${clientId}--radio-label-text`
  }), label) : null);
};
exports.Radio = Radio;
//# sourceMappingURL=Radio.js.map